import {MapMarker, Tooltip} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'
import {tagToUrl} from 'src/shared/utils'

import {classes} from './CourierPlacemark.classes'
import type {PerformerState} from './CourierPlacemark.types'

type Props = {
  performer: PerformerState
  bubbleText?: string
}

const toPercentStr = (num: number) => `${num * 100}%`
const getCourierStyle = (rotate: number, x: number = 0.5, y: number = 0.5) =>
  `rotate(${rotate}deg) translate(-${toPercentStr(x)}, -${toPercentStr(y)})`

const CourierPlacemark: React.FC<Props> = ({performer, bubbleText}) => {
  const style: React.CSSProperties | undefined = performer.direction
    ? {
        transform: getCourierStyle(performer.direction, performer.anchor?.x, performer.anchor?.y),
      }
    : undefined
  const children = performer.tag ? (
    <img alt="" className={classes.root} src={tagToUrl(performer.tag)} style={style} />
  ) : (
    <div className={clsx(classes.root, classes.defaultCourier)} style={style} />
  )

  return (
    <MapMarker coordinates={performer.point}>
      {bubbleText ? (
        <Tooltip autoFlip={false} className={classes.tooltip} opened portal={false} title={bubbleText}>
          {children}
        </Tooltip>
      ) : (
        children
      )}
    </MapMarker>
  )
}

export default CourierPlacemark
